import { combineReducers } from "redux"
import Layout from "./layout/reducer"
import Login from "./auth/login/reducer"
import Account from "./auth/register/reducer"
import ForgetPassword from "./auth/forgetpwd/reducer"
import Profile from "./auth/profile/reducer"
import Spinners from "./spinner/reducer"
import Intro from "./intro/reducer"
import SignalR from "./signalR/reducer"
import Main from "./main/reducer"
import Languages from "./language/reducer"
import Translations from "./translation/reducer"

const rootReducer = combineReducers({
  Layout,
  Login,
  Account,
  ForgetPassword,
  Profile,
  Spinners,
  Intro,
  SignalR,
  Main,
  Languages,
  Translations,
})

export default rootReducer
